import PublicApi from "shared/enums/PublicApi";
import { UseGetTemplatesInput } from "./types";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import { ApiSocialPostParticipantTemplate } from "shared/types/ApiSocialPostParticipantTemplate";
import { ApiSocialPostTemplate } from "apps/console/modules/registration/configurations/socialMedia/list/types";

export function useUploadTemplate() {
  return usePostApiData<ApiSocialPostParticipantTemplate, FormData>(PublicApi.SOCIAL_MEDIA_UPLOAD, {
    clientOptions: { trimAndRemoveNull: false }
  });
}

export function useGetImageBase64(imageUrl?: string, isEnabled?: boolean, successHandler?: (data: string) => void) {
  return useGetApiData<string>(
    PublicApi.GET_IMAGE_BASE64,
    { params: { imageUrl } },
    {
      enabled: isEnabled && Boolean(imageUrl),
      onSuccess: base64 => successHandler?.(base64)
    }
  );
}

export function useGetTemplates(input: UseGetTemplatesInput) {
  return useGetApiData<Array<ApiSocialPostTemplate>>(
    input.listApi,
    {
      params: {
        registrationId: input.registrationId,
        registrationParticipantId: input.registrationParticipantId
      }
    },
    {
      enabled: Boolean(input.registrationId),
      onSuccess: data => {
        input.successHandler(data);
      },
      queryKey: [input.listApi, input.registrationId]
    }
  );
}
